const findReplace = ({
	editor,
	find,
	replaceWith,
	options = { caseSensitive: false, wholeWord: true, preventScroll: true },
}) => {
	editor.find(find, options)
	editor.replaceAll(replaceWith.value)
}

export default findReplace
